import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import LimitOrder from './LimitOrder';
import OrderBookRow from './OrderBookRow';
import MarketOrders from './MarketOrders';
import * as firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

const quips = ["Calling in favors...", "Embezzling Funds...", "Betting against USD...", "Misplaced your cash...", "On the phone with the SEC..."];

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class OrderbookContainer extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
        this.state = {
            orders: [],
            // midPoints: [],
            paused: true,
            LastPrice: '-',
            priceTimes: 0,
            focused: false,
            quip: quips[Math.floor(Math.random() * quips.length)]
        };
        this.vwapRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Assets").child("INTC");

        this.vwapRef.once('value', snap => {
          console.log("VWAP",snap.val());
          if (snap.val()) {
              this.setState({
                  LastPrice: ((parseFloat(snap.val().CurrentAssetPrice) + 25) / 100).toFixed(2),
                  priceTimes: 1
              });
          } else {
              this.setState({
                  LastPrice: '20.00'
              });
          }
          console.log(this.state.LastPrice);
        });

    }

    //sets quip state to display quips on a timer
    getQuip() {
        //console.log("OrderbookContainer getQuip");
        this.setState({
            quip: quips[Math.floor(Math.random() * quips.length)]
        })
    }

    componentDidMount() {
        //console.log("OrderbookContainer componentDidMount");
        this.aggobRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("AggOB");
        this.middlePointRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData");
        this.pausedRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child('StartSim').child('State');
        this.valRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("orderbook");

        //declares quip automation timer
        this.quipsTimer = setInterval(this.getQuip.bind(this), 5000);

        let strike, bid, ask;

        //this listener deals with determining if the sim is paused
        this.pausedRef.on('value', snap => {
            let rawData = snap.val();
            if (rawData === "Running") {
                this.setState({
                    paused: false
                });
            } else if (rawData === "Paused" || rawData === "Over") {
                this.setState({
                    paused: true
                });
            }
        });

        //this listener deals with checking the middle bid
        //and ask points
        // this.middlePointRef.on('value', snap => {
        //   let rawData = snap.val();
        //   if (!!rawData) {
        //     var midPoints = [];
        //     //let midPoints = [];
        //     //console.log(rawData);
        //     midAsk = rawData.ask;
        //     midBid = rawData.bid;
        //     midPoints.push({
        //       midAsk: midAsk,
        //       midBid: midBid
        //     });
        //     //console.log(midAsk,midBid);
        //     this.setState({
        //       midPoints: midPoints
        //     });
        //   }
        // })

        //this listener deals with getting current strikes, bid,
        //and ask. Also deals with setting ready state
        this.aggobRef.on('value', snap => {
            let rawData2 = snap.val();
            if (rawData2) {
                //console.log(rawData);
                var range = Object.keys(rawData2).map(y=>parseInt(y))
                var min = Math.min.apply(null, range)
                var max = Math.max.apply(null, range)
                var masterObj={}
                Array(((max-min)/5) + 1).fill().map((_,i)=> min + i*5).map(akey=>{masterObj[akey] = {Strike: akey.toString(), Bid: 0, Ask: 0}})
                var rawData = Object.assign(masterObj, rawData2);

                var ords = [];
                for (var key in rawData) {
                    //rawStrike = key;
                    strike = (key / 100).toFixed(2);
                    bid = rawData[key].Bid;
                    if (bid === undefined) {
                        bid = 0;
                    }
                    ask = rawData[key].Ask;
                    if (ask === undefined) {
                        ask = 0;
                    }
                    if (bid === 0) {
                        bid = "";
                    }
                    if (ask === 0) {
                        ask = "";
                    }
                    ords.push({
                        "Strike": strike,
                        "Bid": bid,
                        "Ask": ask
                    });
                }
                this.setState({
                    orders: ords.reverse(),
                    ready: true
                });
                this.props.onReady();
            } else {
                //var ords = [];
                this.setState({
                    orders: ords,
                    ready: false
                });
            }
        })
    }

    componentWillUnmount() {
        //console.log("OrderbookContainer componentWillUnmount");
        clearInterval(this.quipsTimer);
        this.aggobRef.off();
        this.middlePointRef.off();
        this.pausedRef.off();
    }

    wasScrolled(){
      this.setState({focused: true});
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        return (
            <div className="orderBookContainerStyle">
                <MarketOrders
                    institution={this.props.institution}
                    paused={this.state.paused}
                    uid={this.props.uid}
                    sessionid={this.props.sessionid}
                />
                <Table className='orderBookTableStyle'>
                    <TableHead className='orderBookHeader'>
                    <TableRow className='orderBookRow'>
                        <TableCell className='orderBookCell bidInput'>Limit Bid</TableCell>
                        <TableCell className='orderBookCell bid'>Bids</TableCell>
                        <TableCell className='orderBookCell strike'>Strike</TableCell>
                        <TableCell className='orderBookCell ask'>Asks</TableCell>
                        <TableCell className='orderBookCell askInput'>Limit Ask</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody className='orderBookTableBody'>
                    {this.state.ready
                        ?
                        this.state.orders.map(function (ord, index) {
                            return (
                                <OrderBookRow
                                    institution={this.props.institution}
                                    paused={this.state.paused}
                                    key={`${JSON.stringify(ord.toString())}:${index}`}
                                    uid={this.props.uid}
                                    sessionid={this.props.sessionid}
                                    Bid={ord.Bid}
                                    Strike={ord.Strike}
                                    StartCenter={!this.state.focused && this.state.LastPrice == ord.Strike}
                                    WasScrolled={this.wasScrolled.bind(this)}
                                    Ask={ord.Ask}/>
                            );
                        }.bind(this))
                        :
                        <TableRow>
                            <div>
                                {this.state.quip}
                            </div>
                        </TableRow>
                    }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

OrderbookContainer.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default OrderbookContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/OrderbookContainer.js